import { render, staticRenderFns } from "./fkGuanKong.vue?vue&type=template&id=06d82654&"
import script from "./fkGuanKong.vue?vue&type=script&lang=js&"
export * from "./fkGuanKong.vue?vue&type=script&lang=js&"
import style0 from "./fkGuanKong.vue?vue&type=style&index=0&id=06d82654&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports